import { render, staticRenderFns } from "./AdminAccount.vue?vue&type=template&id=2912beb8&scoped=true&"
import script from "./AdminAccount.vue?vue&type=script&lang=ts&"
export * from "./AdminAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2912beb8",
  null
  
)

export default component.exports